<template lang="html">
  <div class="response-tabs-q">
    <div v-if="loading"></div>
    <div v-else-if="!error">
      <div class="block">
        <div class="block-content" v-if="data">
          <div v-for="(item, index) in data" :key="index" class="item">
            <div>
              {{ item.question.text }}
            </div>
            <div>
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="error" class="error">
      {{ $tr('common.errrorLoadingPageContent') }}
    </div>
</div>
</template>

<script>
export default {
  name: 'process-response-tab-questionnaire',

  props: {
    response: Object
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/questionnaireLanding/questionnaire/fetch', this.response)
    }
  },

  computed: {
    store () {
      return this.$store.state.process.questionnaireLanding.questionnaire
    },

    data () {
      return this.store.data
    },

    loading () {
      return this.store.loading
    },

    error () {
      return this.store.error
    }
  },

  beforeMount () {
    this.fetch()
  }
}
</script>

<style lang="scss" scoped>
  .response-tabs-q {
    padding-top: 20px;
    padding-left: 12px;
    .block {
      margin-right: 40px;

      .block-content {
        .item {
          padding: 10px 0px;
          display: flex;
          width: 100%;
          div {
            width: 50%;
          }
          div + div {
            padding-left: 20px;
          }
        }
      }
    }
  }
</style>
